<template>
  <div class="row border rounded px-3 py-4 m-3">
    <div class="col-2 d-flex align-items-center">
      <label for="layout-proportions-bar" class="form-label m-0">
        {{ $t("backend.candidacy.components.jumbotron.proportions") }}
      </label>
    </div>

    <div class="col-10">
      <ul class="d-flex align-items-center justify-content-between mb-2 p-0">
        <li
          v-for="(step, i) in jumbotronLayouts"
          :key="`layout_step_${step.join()}`"
          class="list-group-item p-0 m-0"
        >
          <button
            :class="`btn btn-sm ${
              i == selectedLayoutIndex ? 'btn-primary' : 'btn-secondary'} m-0 py-1 px-2 d-flex gap-2 ${
              direction === 'ltr' ? 'flex-row' : 'flex-row-reverse'}`"
            @click.prevent.stop="selectedLayoutIndex = i"
          >
            <span class="d-flex flex-column align-items-center justify-content-center lh-1">
              <AVIcon icon="image" />
              <span class="m-0">{{ step[0] }}</span>
            </span>
            <span class="d-flex flex-column align-items-center justify-content-center lh-1">
              <AVIcon :icon="direction === 'ltr' ? 'align-left' : 'align-right'" />
              <span class="m-0">{{ step[1] }}</span>
            </span>
          </button>
        </li>
      </ul>
      <input
        type="range"
        v-model="selectedLayoutIndex"
        step="1"
        min="0"
        :max="jumbotronLayouts.length-1"
        id="layout-proportions-bar"
        class="form-range"
        style="padding: 0 1.5rem;"
      />
      <input
        v-for="l in layout"
        :key="`hidden_${scopeToId([...scope, 'layout', ''])}`"
        :name="scopeToName([...scope, 'layout', ''])"
        type="hidden"
        :value="l"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType, LayoutOrientation, LayoutProportions } from "@/types";
import { computed } from "vue";
import { scopeToId, scopeToName } from "@/lib/candidacy/form_builder/utils";

const emits = defineEmits<{"update:layout": [[string, string]]}>();

const jumbotronLayouts: LayoutProportions[] = [
  ["30", "70"],
  ["40", "60"],
  ["50", "50"],
  ["60", "40"],
  ["70", "30"],
];

const props = defineProps({
  layout: {
    type: Object as PropType<LayoutProportions>,
    required: true,
  },
  scope: {
    type: Array as PropType<string[]>,
    required: true,
  },
  direction: {
    type: String as PropType<LayoutOrientation>,
    required: true,
  },
});

const selectedLayoutIndex = computed<number>({
  get: () => {
    return jumbotronLayouts.findIndex(layoutEquivalence => layoutEquivalence.join() === props.layout.join());
  },
  set: (value) => {
    emits('update:layout', jumbotronLayouts[value]);
  },
});

</script>
